export default [
    {
        path: '/competencias',
        view: 'competencias/Index',
        name: 'Competências',
        permissions: ['ADMINISTRADOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Competências',
                disabled: true,
                exact: true,
                to: '/competencias',
            },
        ],
    },
    {
        path: '/competencias/novo',
        view: 'competencias/New',
        name: 'Cadastrar Competência',
        permissions: ['ADMINISTRADOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Competências',
                disabled: false,
                exact: true,
                to: '/competencias',
            },
            {
                text: 'Novo',
                disabled: true,
                exact: true,
                to: '/competencias/novo',
            }
        ],
    },
    {
        path: '/competencias/editar/:id',
        view: 'competencias/Edit',
        name: 'Edição de Competência',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Competências',
                disabled: false,
                exact: true,
                to: '/competencias',
            },
            {
                text: 'Editar',
                disabled: true,
                exact: true,
                to: '/competencias/editar/:id',
            }
        ],
    },
    {
        path: '/competencias/excluir',
        permissions: ['ADMINISTRADOR']
    },
];
